"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var debug_1 = __importDefault(require("debug"));
var services_1 = require("../services");
var entities_1 = __importDefault(require("../entities"));
var types_1 = require("../types");
var debug = debug_1.default('app:services:apiMiddleware');
var normalize = entities_1.default.utils.normalize;
function createApiMiddleware(apiClient) {
    return function (_a) {
        var dispatch = _a.dispatch;
        var dispatchResponseAction = middlewareHelpers.handleAPIResponse.bind(null, dispatch);
        return function (next) { return function (action) {
            var nextResult = next(action);
            if (!middlewareHelpers.isActionWithAPICall(action)) {
                return nextResult;
            }
            debug('handleApiAction', action);
            var request;
            if (middlewareHelpers.isActionWithCustomQuery(action)) {
                var _a = action.payload, query = _a.query, variables = _a.variables;
                request = apiClient.makeRequestWithCustomQuery({
                    query: query,
                    variables: variables,
                    action: action,
                });
            }
            else {
                var _b = action.payload, method = _b.method, variables = _b.variables;
                request = apiClient.makeRequestWithAction({
                    method: method,
                    variables: variables,
                    action: action,
                });
            }
            return request
                .then(function (response) {
                dispatchResponseAction(response);
            })
                .catch(function (response) {
                dispatchResponseAction(response);
            });
        }; };
    };
}
function isActionWithAPICall(action) {
    return action && action.meta && action.meta.isApiCall;
}
function isActionWithCustomQuery(action) {
    return action && action.meta && action.meta.isCustomQuery;
}
function isFailResponse(resp) {
    return typeof resp.error !== 'undefined';
}
function suffixActionType(actionType, suffix) {
    var _a = actionType.split(':'), type = _a[0], prevSuffix = _a[1];
    return prevSuffix ? type + ":" + suffix : type;
}
function makeResponseAction(payload, requestAction, typeSuffix) {
    var action = {
        type: middlewareHelpers.suffixActionType(requestAction.type, typeSuffix),
        payload: payload,
        meta: {
            requestAction: requestAction,
        },
    };
    if (typeSuffix === types_1.App.ActionTypeSuffix.FAIL) {
        action.error = true;
    }
    if (requestAction.meta.group) {
        action.meta.group = middlewareHelpers.suffixActionType(requestAction.meta.group, typeSuffix);
    }
    return action;
}
function sendErrorToSentry(info) {
    if (middlewareHelpers.isFailResponse(info)) {
        var error_1 = info.error, actions_1 = info.actions;
        services_1.sentryHub.withScope(function (scope) {
            scope.setTag('origin', 'APIMiddleware');
            scope.setExtras(actions_1);
            services_1.sentryHub.captureException(error_1);
        });
    }
    else {
        services_1.sentryHub.withScope(function (scope) {
            scope.setTag('origin', 'APIMiddleware');
            scope.setExtras({ info: info });
            services_1.sentryHub.captureException(info);
        });
    }
}
function handleAPIResponse(dispatch, apiResp) {
    if (middlewareHelpers.isFailResponse(apiResp)) {
        middlewareHelpers.sendErrorToSentry(apiResp);
        var actions = apiResp.actions, error_2 = apiResp.error;
        console.error('Error', error_2, actions);
        actions.forEach(function (currentAction) {
            dispatch(middlewareHelpers.makeResponseAction({
                error: [error_2],
                args: currentAction.payload.args,
            }, currentAction, types_1.App.ActionTypeSuffix.FAIL));
        });
        return;
    }
    var response = apiResp.response, action = apiResp.action;
    var args = action.payload.args; // TODO: check if payload exists
    if (response.errors) {
        console.error('GQLError', response.errors, action);
        dispatch(middlewareHelpers.makeResponseAction({ error: response.errors, args: args }, action, types_1.App.ActionTypeSuffix.FAIL));
        return;
    }
    var data = normalize(response.data);
    if (!data)
        return;
    if (data.entities && data.result) {
        // TODO: not destructuring args
        dispatch(middlewareHelpers.makeResponseAction(__assign(__assign({}, args), data), action, types_1.App.ActionTypeSuffix.SUCCESS));
        return;
    }
    dispatch(middlewareHelpers.makeResponseAction(__assign(__assign({}, args), { data: data }), action, types_1.App.ActionTypeSuffix.SUCCESS));
}
var middlewareHelpers = {
    createApiMiddleware: createApiMiddleware,
    isActionWithAPICall: isActionWithAPICall,
    isFailResponse: isFailResponse,
    suffixActionType: suffixActionType,
    makeResponseAction: makeResponseAction,
    sendErrorToSentry: sendErrorToSentry,
    handleAPIResponse: handleAPIResponse,
    isActionWithCustomQuery: isActionWithCustomQuery,
};
exports.default = middlewareHelpers;
//# sourceMappingURL=middleware.js.map